var map = {
	"./1WWD.svg": 6794,
	"./2ABB.svg": 1279,
	"./2ATA.svg": 8437,
	"./2EEE.svg": 3832,
	"./2FFF.svg": 775,
	"./2NNN.svg": 4701,
	"./2SRR.svg": 1437,
	"./2UUU.svg": 1249,
	"./9DAC.svg": 3607,
	"./9EUR.svg": 8080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 236;